module.exports = __webpack_public_path__ + "img/voice.5ab8b3a3.svg";